export default {
  leverText: "Hello and welcome!\n" +
  "I am Clank and I will accompany you on this site visit.\n\n" +
  "Before you pull the lever, make sure to keep these 3 interactions in mind:\n\n" +
  "🟢 Green: I speak.\n" +
  "🟠 Orange: You can click.\n" +
  "🔴 Red: You can click, and I will speak to you at the same time.\n\n" +
  "Enjoy yourself!",
  nav: {
    home: "Home",
    projects: "Projects",
    playground: "Playground",
  },
  carouselProjects: {
    scrollToExploreTheProject: "Scroll to explore the project",
  },
  projects: {
    algoForge: {
      description:
        "AlgoForge is a free and open-source web application for algorithm design, created by students, for students. It stands out for its simplicity, speed, and adherence to the IUT of Bayonne’s formal standards. Accessible from any device, it offers a dynamic interface, export-accurate rendering, useful shortcuts, and collaborative features. We focused on eco-responsibility and performance, which guided both our choice of technologies and our development approach.",
      pitch: "An interactive graphical editor for designing algorithms.",
    },
    clim6440: {
      description:
        "Clim 64-40 is the showcase website of an HVAC craftsman, a project I carried out in two main stages. The first part focused on design: creating the logo and developing a complete graphic charter, with all the thought process behind the brand’s visual identity. I then applied this charter to both physical materials (business cards, flyers) and digital ones, through the creation of the website. Since the goal was for the craftsman to easily and quickly update the site himself, the choice naturally turned to a CMS — in this case, WIX.",
      pitch:
        "A showcase website for an HVAC craftsman, allowing visitors to discover his services, view his work, and get in touch.",
    },
  },
  links: {
    github: "Visit the GitHub",
    wiki: "Visit the wiki",
    browser: "Visit the website",
  },
  descriptionLabel: "Description",
  technologiesLabel: "Technologies",
  musicCredit: "Music by Lidrima",
  visitMyGithub: "Visit my GitHub",
  visitMyLinkedin: "Visit my LinkedIn",
  nameInfo: "Wow, sounds like a name for a great guy!",
} as const;
